<template>
  <div>
    <product-collection v-for="productCollection in productCollections"
                        :key="productCollection.id"
                        :product-collection="productCollection"
                        @revealProductDetail="onRevealProductDetail"
    />
  </div>
</template>

<script>
import productCollection from './product-overview/ProductCollection'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductOverviewComponent',
  components: {
    productCollection
  },
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters('shop', ['shopFilterEntityIds']),
    ...mapGetters('selection', ['productCollectionsForConfigurations']),
    productCollections: function () {
      return ([...this.productCollectionsForConfigurations])
        .sort((a, b) => a.order !== b.order ? a.order - b.order : a.title.localeCompare(b.title))
    }
  },
  methods: {
    onRevealProductDetail: function (product, customerGroup, term) {
      this.$emit('revealProductDetail', product, customerGroup, term)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductOverview.vue